import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "../style.css";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../Context/Context";
import { timezonechange } from "../Commonfun";
import Loader from "../CommonLoader";
import { Link } from "react-router-dom";
import DatagridComp from "../DatagridComp";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import UserActivityTracker from "../../../hooks/userActivityTracker";


export default function SupportTicket() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [autoheightval, SetAutoheightval] = useState(true);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [faqData, setfaqData] = useState("2");
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata?.apiauthkey?.value;
  let detailurl = `${process.env.REACT_APP_DOMAIN}ticketdetail/`;


  useEffect(() => {
    callUserdataApi();
    faqdatafun();
  }, []);

  const columns = [

    {
      field: "title",
      headerName: "Title Summary",
      description: "A short title summarizing the ticket",
      minWidth: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
    },
    {
      field: "description",
      headerName: "Description",
      description: "A brief details about the ticket",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
    {
      field: "status",
      headerName: "Status",
      description: "The current state or progress of the ticket",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      // renderCell: (cardData) => {
      //   return cardData.row.is_open === true ? (
      //     <span>Open</span>

      //   ) : (

      //     <span>Closed</span>

      //   );
      // },
    },
    {
      field: "created_at",
      headerName: "Created On",
      description: "The date and time when the ticket was created.",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      valueGetter: (params) => {
        const dateStr = params.row?.created_at;
        if (!dateStr) return null;
        const parsed = new Date(dateStr);
        if (!isNaN(parsed)) return parsed;
        const fixedStr = dateStr.replace(/(\d{2}:\d{2})$/, "$1:00");
        return new Date(fixedStr);
      },
      renderCell: (cardData) => {
        return (timezonechange(cardData?.row?.created_at));
      },
    },


    {
      field: "View",
      headerName: "View",
      minWidth: 130,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      headerClassName: "hide_option",
      renderCell: (cardData) => {
        return (
          <a href={detailurl + `${cardData.row.id}`}>
            <button className="view-report-button">View Detail</button>
          </a>
        );
      },
    },
  ]
  const rows = cardData ?? [];
  const callUserdataApi = async () => {
    setLoading(true);
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}support_tickets/get_ticket/?is_closed=false`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });

      const dataval = datavalue?.data;
      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        SetAutoheightval(false);
        setCardData(newData);
      } else {
        SetAutoheightval(true);
        setCardData("");
      }
      setLoading(false);
    } catch (err) {
      setCardData("");
      if (err.code == "ERR_NETWORK") {
        navigate("/*");
      }
    }
  }

  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }
    setToggle((pre) => !pre);
  };

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=70`;

    try {
      const doaminsectiondatavalue = await axios
        .get(datavar, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs);
      }
    } catch (err) { }
  };

  return (
    <div
      className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Support Ticket</title>
      </Helmet>
      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Support Ticket
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Support Ticket', active: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time" style={{ borderLeft: "none" }}>
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
            </Grid>

            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >
                <button
                  className="btn_dashboard"
                  onClick={() => navigate("/support-form")}
                // disabled={!freesiteaudit.status}
                >
                  Create Ticket
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "30px", marginBottom: "0px" }} >
        <Box style={{ padding: "0px 20px 0px 20px" }}>
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={12}>
              <div className="trendy-tabs-wrapper">
                <div className="trendy-tab-container">
                  <Link to="/support-open-ticket-list" >
                    <button type="button"
                      className={`trendy-tab active`}  >Open Ticket</button>
                  </Link>
                  <Link to="/support-closed-ticket-list" >
                    <button type="button"
                      className={`trendy-tab`}  >Closed Ticket</button>
                  </Link>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 300]}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {toggle && (
        <Rightsidebar
          close={() => setToggle(false)}
          setToggle={setToggle}
          initialfaqDateval={initialfaqDateval}
        />
      )}
      <UserActivityTracker pagename="Support Ticket - Open Tickets" />

      {/* <div className="top_breadcrumb_menu">
        <CommonBreadCrumb breadcrumbValue={[
          { title: 'Support Ticket', active: true }
        ]} />
      </div>

      <div className="cnt_audit_outer_wrap">

        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div style={{ display: "flex" }}>
              <h2
                className="heading_font"
                style={{
                  letterSpacing: "0.8px",
                  fontWeight: 900,
                  color: "#ff601f",
                }}
              >
                Support Ticket
              </h2>

            </div>
          </div>
          <button
            className="runreportnew"
            onClick={() => navigate("/support-form")}
          >
            Create Ticket
          </button>

        </div>
        <div className="center_tab accessbility_button_tap">
          <Link to="/support-open-ticket-list" ><button type="button" className={`runreportnews active`}  >Open Ticket</button></Link>
          
          <Link to="/support-closed-ticket-list" ><button type="button" className={`runreportnews`}  >Closed Ticket</button></Link>
        </div>
        <DatagridComp
          columns={columns}
          rows={rows}
          autoheightval={autoheightval}
          datagridval={2}
          columnFreezeWidth={[0, 300]}
        />


      </div> */}
    </div >
  );
}
